import * as React from "react";

import { Link, makeStyles, Typography } from "@material-ui/core";

import { logAmplitudeEvent } from "client/lib/amplitude";

const useStyles = makeStyles(() => ({
  text: {
    fontSize: "0.9rem",
  },
}));

export const DirectDebitHelperText: React.FC = () => {
  const classes = useStyles();
  return (
    <Typography className={classes.text} variant="body2">
      Given multiple signatures are required, please{" "}
      <Link
        href="https://get.afterpay.com/new-zealand-direct-debit-agreement-template.pdf"
        rel="noopener noreferrer"
        target="_blank"
        download
        onClick={() => {
          logAmplitudeEvent(
            "REDESIGN_LINK_YOUR_BANK_ACCOUNT",
            "download_multiple_signatories_form"
          );
        }}
      >
        <strong>download this paper form</strong>
      </Link>{" "}
      and upload the signed form.
    </Typography>
  );
};
